"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _kame = _interopRequireDefault(require("../../services/kame"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ProgramLabel extends _react.default.Component {
  state = {
    loading: false,
    programId: null,
    program: null
  };
  static getDerivedStateFromProps(props, state) {
    if (props.programId === state.programId) {
      return null;
    }
    return {
      programId: props.programId,
      program: null
    };
  }
  componentDidMount() {
    const {
      programId,
      program,
      loading
    } = this.state;
    if (!loading && programId && programId !== program?.id) {
      this.loadProgram(this.state.programId);
    }
  }
  componentDidUpdate() {
    const {
      programId,
      program,
      loading
    } = this.state;
    if (!loading && programId && programId !== program?.id) {
      this.loadProgram(this.state.programId);
    }
  }
  render() {
    const {
      programId,
      ...props
    } = this.props;
    const {
      loading,
      program
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("span", props, programId && program?.id === programId ? /*#__PURE__*/_react.default.createElement("span", null, program.name) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
      size: "small"
    }) : /*#__PURE__*/_react.default.createElement("span", null));
  }
  loadProgram = async programId => {
    const {
      auth
    } = this.props;
    this.setState({
      loading: true
    });
    try {
      const kameService = new _kame.default(auth.state);
      const program = await kameService.getProgram(programId);
      this.setState({
        program,
        loading: false
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false,
        program: {
          id: programId,
          name: '¯\\_(ツ)_/¯'
        }
      });
    }
  };
}
exports.default = ProgramLabel;
//# sourceMappingURL=program-label.js.map